export const sampleMonthlyReviews = [
  {
    monthNumber: 1,

    score: 46,

    stats: {
      total: 58,
      done: 27,
      planned: 25,
      cancelled: 6
    },

    bestDay: "Monday",
    weakDay: "Wednesday",

    objectives: {
      Learning: 18,
      Discipline: 16,
      Focus: 10,
      Productivity: 7,
      Career: 4,
      Health: 3
    },

    signals: {
      focus: 52,
      consistency: 68,
      discipline: 47,
      resilience: 29
    },

    roach: {
      avgScore: 3,
      type: "Recovering Survivor"
    },

    weaknesses: [
      "Phone distraction spikes",
      "Weekend inconsistency",
      "Low recovery routine"
    ],

    insights: [
      "Awareness phase successfully established.",
      "Task completion improving steadily.",
      "Discipline still depends on motivation."
    ]
  },

  {
    monthNumber: 2,

    score: 71,

    stats: {
      total: 61,
      done: 48,
      planned: 11,
      cancelled: 2
    },

    bestDay: "Tuesday",
    weakDay: "Saturday",

    objectives: {
      Learning: 15,
      Discipline: 14,
      Focus: 11,
      Productivity: 8,
      Career: 9,
      Health: 4
    },

    signals: {
      focus: 74,
      consistency: 84,
      discipline: 69,
      resilience: 57
    },

    roach: {
      avgScore: 6,
      type: "Adaptive Survivor"
    },

    weaknesses: [
      "Energy fluctuations",
      "Occasional procrastination"
    ],

    insights: [
      "Execution becoming habit-driven.",
      "Recovery from setbacks much faster.",
      "Focus sessions increasing in quality."
    ]
  },

  {
    monthNumber: 3,

    score: 91,

    stats: {
      total: 65,
      done: 59,
      planned: 5,
      cancelled: 1
    },

    bestDay: "Thursday",
    weakDay: "-",

    objectives: {
      Career: 18,
      Discipline: 12,
      Learning: 12,
      Focus: 10,
      Productivity: 8,
      Health: 5
    },

    signals: {
      focus: 88,
      consistency: 93,
      discipline: 90,
      resilience: 82
    },

    roach: {
      avgScore: 9,
      type: "Focused Builder"
    },

    weaknesses: [],

    insights: [
      "Behavior now driven by identity rather than motivation.",
      "Execution remains stable under stress.",
      "Transformation cycle successfully completed."
    ]
  }
];